// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-syf4","right":"styles_right__3-d0H"};